import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import FilledInput from '@mui/material/FilledInput';
import ComponentStyles from 'styles/mixins/Component.styles';

const StyledFilledInput = styled(FilledInput)`
  ${ComponentStyles}
`;

StyledFilledInput.propTypes = {
  theme: PropTypes.object
};

export default StyledFilledInput;
